// extracted by mini-css-extract-plugin
export var centerText = "_6c-8";
export var container = "_6c-0";
export var doughnutContainer = "_6c-7";
export var legend = "_6c-a";
export var legendItemColorDisplay = "_6c-b";
export var legendItemLabel = "_6c-d";
export var legendItemValue = "_6c-c";
export var lg = "_6c-5";
export var maxWidth = "_6c-9";
export var md = "_6c-4";
export var responsive = "_6c-6";
export var sm = "_6c-3";
export var xs = "_6c-2";
export var xxs = "_6c-1";